import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PDVSalesReportData } from '@arema/types/internal';
import { Button, SegmentControl, Table } from 'react-frontier2';
import { addCommas } from '@arema/components/Util';
import { Link } from 'react-router-dom';
import { ReportDownloadLink } from '../../AdminClasses';

interface PdvSalesReportProps{
	data: PDVSalesReportData[],
	downloads?: ReportDownloadLink[],
}

enum ReportType{
	SUMMARY = 0,
	DETAILED = 1,
}

var PdvSalesReport = (props: PdvSalesReportProps)=>{
	var { t } = useTranslation();
	var [report, setReport] = useState<ReportType>(ReportType.SUMMARY);

	var summary = useMemo(()=>{
		var data : {
			pdv_id: number,
			pdv_name: string,
			tickets: number,
			ticket_cost: number,
			commission: number,
		}[] = [];
		for(var i of props.data){
			data.push(i.events.reduce((a,b)=>{
				a.tickets += b.tickets;
				a.ticket_cost += b.ticket_cost;
				a.commission += b.commission;
				return a;
			}, {
				pdv_id: i.pdv_id,
				pdv_name: i.pdv_name,
				tickets: 0,
				ticket_cost: 0,
				commission: 0,
			}))
		}
		return data;
	}, [props.data]);
	
	return <div>
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto', marginTop: 15, marginBottom: 15, gap: 10, width: '100%' }}>
			<SegmentControl segments={[
				{ text: 'Resumen', value: ReportType.SUMMARY },
				{ text: 'Detallado', value: ReportType.DETAILED },
			]} onClick={setReport} selected={report} style={{ maxWidth: 400, width: '100%', flexGrow: 100 }} />
			<Button text='Descargar' color='blue' iconRight='caret-down' menu={(
				props.downloads?.map((a, i)=>(
					{ text: a.text, iconName: a.icon, as: Link, to: a.url, target: '_blank', key: `DWL-${i}` }
				))
			)} />
		</div>
		{report===ReportType.SUMMARY ? (
			<Table striped style={{ maxWidth: 800, margin: 'auto' }}>
				<Table.Head collapsingIndexes={[0, 2, 3, 4, 5]} data={[[ 'ID', 'PDV', 'Boletos', 'Importe', 'Cargo servicio', 'Total' ]]} />
				<Table.Body>
					{summary.map(a=>(
						<Table.Row
							collapsingIndexes={[0, 2, 3, 4, 5]}
							key={`PVDL-${a.pdv_id}`}
							data={[
								<Link to={`/pdv/${a.pdv_id}`} className={'normal'}>{a.pdv_id}</Link>,
								a.pdv_name,
								addCommas(a.tickets, false),
								addCommas(a.ticket_cost),
								addCommas(a.commission),
								addCommas(a.ticket_cost+a.commission),
							]}
						/>
					))}
				</Table.Body>
			</Table>
		) : (
			props.data.map(a=>{
				var pdv_summary = summary.find(b=>b.pdv_id===a.pdv_id);
				return <Table striped style={{ maxWidth: 1000, margin: 'auto', marginBottom: 10 }} key={`PDVDL-${a.pdv_id}`}>
					<Table.Head title={a.pdv_name} titleRight={(
						<Button text='Ver PDV' size='tiny' as={Link} to={`/pdv/${a.pdv_id}`} />
					)} />
					<Table.Body>
						<Table.Row>
							<Table.Cell colSpan={2}><b>Total</b></Table.Cell>
							<Table.Cell collapsing>{addCommas(pdv_summary?.tickets || 0, false)}</Table.Cell>
							<Table.Cell collapsing>{addCommas(pdv_summary?.ticket_cost || 0)}</Table.Cell>
							<Table.Cell collapsing>{addCommas(pdv_summary?.commission || 0)}</Table.Cell>
							<Table.Cell collapsing>{addCommas((pdv_summary?.ticket_cost || 0)+(pdv_summary?.commission || 0))}</Table.Cell>
						</Table.Row>
						<Table.Row header data={['ID', 'Evento', 'Boletos', 'Importe', 'Cargo servicio', 'Total']} collapsingIndexes={[0, 2, 3, 4, 5]} />
						{a.events.map(e=>(
							<Table.Row
								key={`PDV-${a.pdv_id}-${e.event_id}`}
								collapsingIndexes={[0, 2, 3, 4, 5]}
								data={[
									<Link to={`/events/${e.event_id}`} className={'normal'}>{e.event_id}</Link>,
									e.event_name,
									addCommas(e.tickets, false),
									addCommas(e.ticket_cost),
									addCommas(e.commission),
									addCommas(e.ticket_cost+e.commission),
								]}
							/>
						))}
					</Table.Body>
				</Table>
			})		
		)}
	</div>
}

export default PdvSalesReport;